class ClockTime extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTimes = this.setupTimes.bind(this)
    this.setClock = this.setClock.bind(this)

    this.setupTimes()
  }

  setupTimes () {
    if (!this.els?.time?.exists) return

    setInterval(this.setClock, 1000)
  }

  setClock () {
    const currentDate = new Date(
      new Date().toLocaleString('en-US', { timeZone: this.dataset.timezone }),
    )

    this.els.time.elements.forEach((timeEl) => {
      timeEl.innerText = `${this.padNumber(currentDate.getHours())}:${this.padNumber(currentDate.getMinutes())}:${this.padNumber(currentDate.getSeconds())}`
    })
  }

  padNumber (number) {
    return number < 10 ? `0${number}` : number
  }
}

if (!customElements.get('clock-time')) {
  customElements.define('clock-time', ClockTime)
}
